import { ApplicationRef, Component } from "@angular/core";
import { Location } from "@angular/common";
import { SwUpdate } from "@angular/service-worker";
import { Title } from "@angular/platform-browser";
import { Metrika } from "ng-yandex-metrika";
import { NavigationEnd, Router } from "@angular/router";
import { concat, interval } from "rxjs";
import { filter, first } from "rxjs/operators";
import { HttpService, UserService } from "@app/core/services";
import { environment } from "@env/environment";
import { ToastrService } from "ngx-toastr";
import { ReportNotificationService } from "./core/services/report-notification.service";
import { TranslateService } from "@ngx-translate/core";
import { PhotoReportNotificationService } from "./core/services/photo-report-notification.service";
import { DesignService } from "./core/services/design.service";
import DataGrid from "devextreme/ui/data_grid";

DataGrid.defaultOptions({
  options: {
    scrolling: {
      showScrollbar: "onHover"
    }
  }
});

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  public version = environment.version;

  constructor(
    private titleService: Title,
    private metrika: Metrika,
    private router: Router,
    private location: Location,
    private userService: UserService,
    private httpService: HttpService,
    private toastr: ToastrService,
    private reportNotificationService: ReportNotificationService,
    private photoReportNotificationService: PhotoReportNotificationService,
    private designService: DesignService,
    private translate: TranslateService,
    private swUpdate: SwUpdate,
    private appRef: ApplicationRef
  ) {
    console.log("AppComponent");
    console.log("Build: v3.44.18"); // cache test
    this.checkForUpdates();
    translate.setDefaultLang("ru");
    titleService.setTitle("TR Portal");
    // translate.setDefaultLang('ru');
    let prevPath = this.location.path();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const newPath = this.location.path();

        this.metrika.hit(newPath, {
          referer: prevPath,
          params: {
            userId: this.userService.getUser()
              ? this.userService.getUser()["id"]
              : null,
            login: this.userService.getUser()
              ? this.userService.getUser()["login"]
              : "anonimus",
          },
        });
        // toastr.success("test <a href='https://www.npmjs.com/package/ngx-toastr'> ссылка <a/>","",{enableHtml:true})
        prevPath = newPath;
      });
    reportNotificationService.initialization();
    photoReportNotificationService.initialization();
  }

  private checkForUpdates(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    // При обнаружении новой версии — показать уведомление
    this.swUpdate.versionUpdates.subscribe((event) => {
      if (event.type === 'VERSION_READY') {
        // Не показывать если тоастр уже на экране
        const alreadyShown = this.toastr.toasts.some(
          t => t.title === 'Доступна новая версия сайта'
        );
        if (alreadyShown) return;

        console.log('Новая версия доступна.');
        this.toastr.info(
          'Нажмите сюда, чтобы обновить',
          'Доступна новая версия сайта',
          {
            disableTimeOut: true,
            closeButton: true,
            tapToDismiss: false,
            enableHtml: true,
          }
        ).onTap.subscribe(() => {
          window.location.reload();
        });
      }
    });

    // Ждём стабилизации приложения, затем проверяем обновления периодически
    const appIsStable$ = this.appRef.isStable.pipe(first(isStable => isStable === true));
    const everyMinute$ = interval(60 * 1000);
    concat(appIsStable$, everyMinute$).subscribe(() => {
      this.swUpdate.checkForUpdate();
    });
  }
}
